export default {
  getUnreadNotification: state =>
    state.notifications.filter(notification => {
      return notification.read_at === null;
    }),

  filteredNotification: state =>
    state.notifications.slice().sort(function(a, b) {
      return new Date(b.from_at).getTime() - new Date(a.from_at).getTime();
    }).filter(notification => {
      return (
        notification.title.includes(state.notificationSearchQuery) ||
        notification.content.includes(state.notificationSearchQuery)
      );
    }),

  getNotification: state => notificationId =>
    state.notifications.find(notification => notification.id === notificationId),

  hasUnread: state => {
    return state.unreadNotifications.length !== 0;
  },

  isRead: state => notificationId =>
    state.notifications.find(notification => notification.id == notificationId)
};
